<template>
  <li class="ship-item">
    <div v-if="$isMobile()" class="ship-item__summary">
      <div>
        <span class="ship-item__title">{{ $t('Ship name') }}:</span>
        {{ ship.vesselName }}
      </div>
      <div>
        <span class="ship-item__title">{{ $t('IMO') }}:</span> {{ ship.imo }}
      </div>
      <div><span class="ship-item__title">{{ $t('UCRN') }}:</span> {{ ship.ucrn }}</div>
      <div>
        <span class="ship-item__title">{{ $t('GT') }}:</span> {{ ship.grossTonnage }}
      </div>
      <div>
        <span class="ship-item__title">{{ $t('Date') }}:</span> {{ ship.ata | formatDate }}
      </div>
      <div v-if="ship.hapPlichtig">
        <span class="ship-item__title">{{ $t('DELIVERY ENTITLEMENT') }}: </span>
        <i class="icon-check"></i>
      </div>
    </div>

    <div v-else class="ship-item__summary">
      <div class="ship-item__field ship-item__field--ship-name flex-col flex-col--20">
        <span class="text--bold">
          {{ ship.vesselName }}
        </span>
      </div>
      <div class="ship-item__field ship-item__field--imo
        flex-col flex-col--15 text--right"
      >
        {{ ship.imo }}
      </div>
      <div class="ship-item__field ship-item__field--ucrn
        flex-col flex-col--20 text--right"
      >
        {{ ship.ucrn }}
      </div>

      <div class="ship-item__field
        flex-col flex-col--15 text--right"
      >
        {{ ship.ata | formatDate }}
      </div>
      <div class="ship-item__field ship-item__field--approved
        flex-col flex-col--25 text--center"
      >
        <i
          v-if="ship.hapPlichtig"
          class="icon-check"
        >
        </i>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    ship: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.ship-item {
  flex-wrap: wrap;
  &__summary {
    display: flex;
    justify-content: space-between;
    line-height: 2.1;
    border-top: .1rem solid $gray-300;
    padding: 1rem 0;
    @include media-breakpoint-down(sm) {
      display: block;
    }
  }
  &__field {
    &--ship-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &--approved {
      padding-right: 0;
    }
  }

  &__title {
    text-transform: uppercase;
    font-weight: 900;
  }

  .icon-check {
    color:#75b94e;
  }
}
</style>
